module.exports = __webpack_public_path__ + "static/media/BBs_Brunch_Menu_Front.100dc329.png";